import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function PageHero1({
  title,
  text,
  image,
  video,
  height = "h-[85vh]",
}) {
  return (
    <section className={`relative w-full overflow-hidden ${height}`}>
      
      {/* Background (Image or Video) */}
      <div className="absolute inset-0">
        {video ? (
          <video
            src={video}
            autoPlay
            muted
            loop
            playsInline
            className="h-full w-full object-cover"
          />
        ) : (
          <img
            src={image}
            alt="hero"
            className="h-full w-full object-cover"
          />
        )}

        {/* Dark cinematic overlays */}
        </div>

      {/* Content */}
      <div className="relative z-10 mx-auto flex h-full max-w-7xl flex-col justify-center px-4 sm:px-6 lg:px-8">
        
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl"
        >
          {/* Tag */}
          <span className="inline-block rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-sm font-medium text-sky-300 backdrop-blur">
            Hydrotec Solutions
          </span>

          {/* Title */}
          <h1 className="mt-6 text-4xl font-semibold leading-tight text-white sm:text-5xl lg:text-6xl">
            {title}
          </h1>

          {/* Subtitle */}
          <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-300">
            {text}
          </p>

          {/* CTA */}
          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="/contact"
              className="inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-semibold text-slate-900 transition hover:bg-sky-50"
            >
              Get in Touch
              <ArrowRight className="h-4 w-4" />
            </a>

            <a
              href="/solutions"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-6 py-3 text-sm font-semibold text-white backdrop-blur transition hover:bg-white/10"
            >
              Explore Solutions
            </a>
          </div>
        </motion.div>
      </div>

      {/* Bottom Fade (for smooth transition to next section) */}
      <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-b from-transparent to-slate-950" />
    </section>
  );
}